import {
  ConditionalData,
  BoolExprGroup,
  LBNodeData,
} from '@/proto/logiblocks/logiblocks';
import { CustomizationComponent } from '@/pages/Logiblocks/types';
import { BoolExprGroupEditor } from './BoolExprGroupEditor';

const EMPTY_GROUP: BoolExprGroup = { expressions: [], operators: [] };
const EMPTY_DATA: ConditionalData = { root: EMPTY_GROUP };

/**
 * Editor for the ConditionalNode. Owns the root BoolExprGroup and delegates
 * rendering to BoolExprGroupEditor, which recurses for nested groups.
 *
 * The left-hand variable list comes from the graph's ancestor variables.
 */
export const ConditionalCustomization: CustomizationComponent = ({
  nodeId,
  nodeData,
  onChange,
  isReadOnly = false,
}) => {
  const conditional = nodeData.conditional ?? EMPTY_DATA;
  const root = conditional.root ?? EMPTY_GROUP;

  const handleRootChange = (next: BoolExprGroup) => {
    const updated: LBNodeData = {
      ...nodeData,
      conditional: { root: next },
    };
    onChange(updated);
  };

  return (
    <BoolExprGroupEditor
      nodeId={nodeId}
      group={root}
      onChange={handleRootChange}
      isReadOnly={isReadOnly}
    />
  );
};

// TODO: remove this flag when the component shows inline errors
ConditionalCustomization.showDeprecatedValidationErrorBanner = true;
